/**
 * «ورود به پنل بازاریاب»: this tab may be an admin's read-only view of a partner's panel
 * (apps/api impersonation/). No imports from the API client, so `client.ts` can use it.
 *
 * The admin page to return to is remembered for the tab (sessionStorage): once the 30 minutes are
 * up the view cookie is gone, and a 401 must send the admin back there, never to the partner
 * sign-in (which would start a WHMCS round trip).
 */
const KEY = "mfa-admin-view";

/** Only the admin panel's own partner page: nothing from storage can redirect elsewhere. */
const ADMIN_URL_RE = /^\/admin\/partners\/[1-9][0-9]{0,9}$/;

/** `adminUrl` when it is the admin panel's partner page, else null. */
export function safeAdminUrl(adminUrl: string | null | undefined): string | null {
    return adminUrl && ADMIN_URL_RE.test(adminUrl) ? adminUrl : null;
}

let current: string | null = null;

export function rememberImpersonation(adminUrl: string | null): void {
    current = safeAdminUrl(adminUrl);
    try {
        if (current) window.sessionStorage.setItem(KEY, current);
        else window.sessionStorage.removeItem(KEY);
    } catch {
        // Storage blocked: the in-memory value still covers this page load.
    }
}

/** The admin page this tab returns to while it is (or just was) an admin's view, else null. */
export function impersonationAdminUrl(): string | null {
    if (current) return current;
    try {
        return safeAdminUrl(window.sessionStorage.getItem(KEY));
    } catch {
        return null;
    }
}

let lastNotice = 0;

/** 403 `impersonation_read_only`: true only for the first refusal in a burst, so one toast covers them all. */
export function firstReadOnlyNotice(now: number = Date.now()): boolean {
    if (now - lastNotice < 4000) return false;
    lastNotice = now;
    return true;
}
